import React from 'react'
import Header from './header'
import MapEmployee from './mapEmployee'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import _ from 'lodash'
import { getMapEmployee } from '../../../actions/employeeActions'


class Index extends React.Component {

    state = {
        searchedString: ''
    }

    componentDidMount() {
        this.props.getMapEmployee()
    }

    _onPress = (value) => {
        this.props.getMapEmployee()
    }

    onSearch = (event) => {
        this.setState({ searchedString: event.target.value })
    }

    render() {
        return (
            <>
                <main id="content" className="app__content" >
                    <Header onPress={this._onPress} handleChange={this.onSearch} />
                    <MapEmployee adminData={this.props.adminData} onPress={this._onPress} searchedString={this.state.searchedString} />
                </main>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        adminData: state.adminData,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getMapEmployee }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Index)
